import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class MailerService {
  constructor(private http: HttpClientService) {}
  public sendMail(from: string, to: string, subject: string, template: string): Observable<any> {
    let options = {
      from: from,
      to: to,
      subject: subject,
      body: template,
    };
    return this.http.post("/api/mailer/send_email", options).pipe(tap((_) => console.log("MailService.sendMail: Ok.")));
  }

  public postMailWithPdf(destinataries, subject, body, filename, filecontent): Observable<any> {
    let params = {
      destinataries: destinataries,
      subject: subject,
      body: body,
      filename: filename,
      filecontent: filecontent,
    };
    return this.http
      .post("/api/mailer/mail_with_pdf", params)
      .pipe(tap((_) => console.log("MailerService.postMailWithPdf: Ok.")));
  }

  public clientSupport(data): Observable<any> {
    return this.http
      .post("/api/mailer/client_support", data)
      .pipe(tap((_) => console.log("MailerService.clientSupport: Ok.")));
  }

  public agencyContact(data): Observable<any> {
    return this.http
      .post("/api/mailer/agency_contact", data)
      .pipe(tap((_) => console.log("MailerService.agencyContact: Ok.")));
  }

  public independentContact(data): Observable<any> {
    return this.http
      .post("/api/mailer/independent_contact", data)
      .pipe(tap((_) => console.log("MailerService.independentContact: Ok.")));
  }

  public requestRegisterSeller(data): Observable<any> {
    return this.http
      .post("/api/mailer/request_register_seller", data)
      .pipe(tap((_) => console.log("MailerService.requestRegisterSeller: Ok.")));
  }

  public requestRegisterAgency(data): Observable<any> {
    return this.http
      .post("/api/mailer/request_register_agency", data)
      .pipe(tap((_) => console.log("MailerService.requestRegisterAgency: Ok.")));
  }

  public contractInconsistentData(data): Observable<any> {
    return this.http
      .post("/api/mailer/contract_inconsistent_data", data)
      .pipe(tap((_) => console.log("MailerService.contractInconsistentData: Ok.")));
  }
}
